export var ITargetImageReferenceObject;
(function (ITargetImageReferenceObject) {
    ITargetImageReferenceObject["wineBottle"] = "wineBottle";
    ITargetImageReferenceObject["sodaCan330ml"] = "sodaCan330ml";
    ITargetImageReferenceObject["sodaCan500ml"] = "sodaCan500ml";
    ITargetImageReferenceObject["sodaBottle2l"] = "sodaBottle2l";
    ITargetImageReferenceObject["none"] = "none";
})(ITargetImageReferenceObject || (ITargetImageReferenceObject = {}));
